import { jsx as _jsx } from "react/jsx-runtime";
import { useInsiderFeatureEligibility } from "@faire/retailer-visitor-shared/hooks/insider/useInsiderFeatureEligibility";
import { useNationality } from "@faire/retailer-visitor-shared/hooks/retailer/useNationality";
import { getInsiderTestimonials, getUSInsiderTestimonials } from "@faire/retailer-visitor-shared/views/user/InsiderMarketing/components/consts";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import * as React from "react";
export var TestimonialTitle = function() {
    var _useNationality = useNationality(), isAmerican = _useNationality.isAmerican, isEurope = _useNationality.isEurope;
    if (isAmerican) {
        return /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "2ti3h+",
            defaultMessage: [
                {
                    type: 0,
                    value: "Thousands of US retailers love Insider"
                }
            ]
        });
    }
    if (isEurope) {
        return /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "Po1Rc+",
            defaultMessage: [
                {
                    type: 0,
                    value: "Thousands of European retailers love Insider"
                }
            ]
        });
    }
    return /*#__PURE__*/ _jsx(StrictLocalMsg, {
        id: "xpYbVE",
        defaultMessage: [
            {
                type: 0,
                value: "Thousands of retailers love Insider"
            }
        ]
    });
};
export var useTestimonials = function() {
    var hasSpecialTestimonial = useInsiderFeatureEligibility().hasSpecialTestimonial;
    if (hasSpecialTestimonial) {
        return getInsiderTestimonials();
    }
    return getUSInsiderTestimonials();
};
